module.exports = __webpack_public_path__ + "fonts/Gotham-Bold.c7244800.otf";